import { ApplicantDetailsResponse } from "@modules/application-section/application-details/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApplicationDetails,
  getSeekClarificationDetails,
  submitSeekClarification,
  submitEOTRequest,
  provisionalPayment,
  finalPayment,
  getFeesDetails,
  submitFinalNOCRequest,
  getReceiptDetails,
  getFeesComponent,
  getPenalityFee,
  getIsCheckApplicationSubmitted,
  submitWithdrawApplication,
  getSeekClarificationDetailsApplicant,
  postSeekClarificationResponse,
  submitReviewRequestApi,
} from "../apiEndPoints";

export const fetchApplicationDetails = createAsyncThunk<
  ApplicantDetailsResponse,
  number | string
>("details/fetchApplicationDetails", async (access_id) => {
  try {
    const response = await getApplicationDetails({
      access_id,
    });
    return response?.data?.data;
  } catch (error: any) {
    return Promise.reject(error);
  }
});

export const fetchSeekClarificationDetailsApi = createAsyncThunk(
  "seekClarification/fetchDetails",
  async (id: any, { rejectWithValue }) => {
    try {
      const response = await getSeekClarificationDetails(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const SubmitSeekClarificationDetailsApi = createAsyncThunk(
  "seekClarification/submit",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await submitSeekClarification(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// EOT Request
export const SendEOTApi = createAsyncThunk(
  "eot-request",
  async ({ payload }: { payload: any }, { rejectWithValue }) => {
    try {
      const response = await submitEOTRequest(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
// Provisional License Payment

export const ProvisionalPaymentThunk = createAsyncThunk(
  "application/provisionalPayment",
  async ({ applicationId }: { applicationId: number }, { rejectWithValue }) => {
    try {
      const response = await provisionalPayment(applicationId); // token handled inside provisionalPayment
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Final NOC Payment

export const FinalPaymentThunk = createAsyncThunk(
  "application/finalPayment",
  async ({ applicationId }: { applicationId: any }, { rejectWithValue }) => {
    try {
      const response = await finalPayment(applicationId);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const FeesDetailsThunk = createAsyncThunk(
  "feesDetails/fetch",
  async ({ applicationId }: { applicationId: any }, thunkAPI) => {
    try {
      const response = await getFeesDetails(applicationId);
      return response.data.data; // assuming your API response shape
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message || "Failed to fetch fees",
      );
    }
  },
);

export const FeesDetailsComponentThunk = createAsyncThunk(
  "feesDetailsComponent/fetch",
  async ({ applicationId }: { applicationId: any }, thunkAPI) => {
    try {
      const response = await getFeesComponent(applicationId);
      return response.data.data; // assuming your API response shape
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message || "Failed to fetch fees",
      );
    }
  },
);

export const submitFinalNOCRequestApi = createAsyncThunk(
  "finalNOC/submit",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await submitFinalNOCRequest(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// receipt-details

export const fetchReceiptDetailsThunk = createAsyncThunk(
  "receipt-details",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getReceiptDetails(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getPenalityFeeThunk = createAsyncThunk(
  "dashboard/getPenalityFee",
  async (_, thunkAPI) => {
    try {
      const response = await getPenalityFee();
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message || "Failed to load filter data",
      );
    }
  },
);

export const getIsCheckApplicationSubmittedThunk = createAsyncThunk(
  "dashboard/getIsCheckApplicationSubmitted",
  async (id: number, thunkAPI) => {
    try {
      const response = await getIsCheckApplicationSubmitted(id);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || error.message || "Failed to load filter data",
      );
    }
  },
);

export const SubmitWithdrawApplicationThunk = createAsyncThunk(
  "withdraw/submit",
  async (
    { payload, application_id }: { payload: any; application_id: any },
    { rejectWithValue },
  ) => {
    try {
      const response = await submitWithdrawApplication(application_id, payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchSeekClarificationDetailsApplicantApi = createAsyncThunk(
  "seekClarification/fetchDetails",
  async (id: any, { rejectWithValue }) => {
    try {
      const response = await getSeekClarificationDetailsApplicant(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const postSeekClarificationResponseThunk = createAsyncThunk(
  "seekClarification/fetchDetails",
  async (id: any, { rejectWithValue }) => {
    try {
      const response = await postSeekClarificationResponse(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);


export const submitReviewRequestThunk = createAsyncThunk(
  "reviewRequest/submit",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await submitReviewRequestApi(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);